(function ($) {

  // javascript code here. i.e.: $(document).ready( function(){} );

  const RANK_MATH_LIST_SELECTOR = ".rank-math-list";

  // rank math  FAQ
  function accordion() {
    if ($(RANK_MATH_LIST_SELECTOR).length > 0) {
      const $accordionContainer = $(RANK_MATH_LIST_SELECTOR),
        opener = $(RANK_MATH_LIST_SELECTOR + " h3"),
        slider = $(RANK_MATH_LIST_SELECTOR + " .rank-math-answer");

      if ($(opener).parent().hasClass("active")) {
        $(".active").find(slider).show();
      }

      $accordionContainer
        .find(opener)
        .click(function (e) {
          const $this = $(this);
          if ($this.parent().hasClass("active")) {
            $this.parent().removeClass("active");
            $this.next(slider).slideUp();
          } else {
            $this.parents($accordionContainer).children(opener).removeClass("active");
            $this
              .parents(RANK_MATH_LIST_SELECTOR)
              .find(".rank-math-answer ")
              .slideUp();
            $this.parent().addClass("active");
            $this.next(slider).slideDown();
          }
          e.preventDefault();
        });
    }
  }
  jQuery(document).ready(function ($) {
    accordion();
  });
})(jQuery);
